import * as actions from "./actionTypes";
import axios from "../../axios_call";
import { BASE_URL } from "../../components/Helpers/helpers";

const userlListStart = () => {
  return {
    type: actions.USER_LIST_START,
  };
};

const userListFail = (error) => {
  return {
    type: actions.USER_LIST_FAIL,
    error: error,
  };
};

const userListSuccess = (message, data, page) => {
  return {
    type: actions.USER_LIST_SUCCESS,
    message: message,
    data: data,
    page: page,
  };
};

const userDeleteAction = (id) => {
  return {
    type: actions.USER_DELETE,
    id: id,
  };
};

const userRoleListAction = (data, error) => {
  return {
    type: actions.USER_ROLE_LIST,
    data: data,
    error: error,
  };
};

const userOrganisationListAction = (data, error) => {
  return {
    type: actions.USER_ORGANISATION_LIST,
    data: data,
    error: error,
  };
};

const userDetail = (data, error) => {
  return {
    type: actions.USER_DETAIL,
    data: data,
    error: error,
  };
};

const userAddEditStart = () => {
  return {
    type: actions.USER_ADD_EDIT_START,
  };
};

const userAddEditFail = (error) => {
  return {
    type: actions.USER_ADD_EDIT_FAIL,
    error: error,
    redirectTo: null,
  };
};

const userAddEditSuccess = (message, data) => {
  return {
    type: actions.USER_ADD_EDIT_SUCCESS,
    message: message,
    data: data,
    redirectTo: "/users",
  };
};

const userFilterList = (text, role) => {
  return {
    type: actions.USER_LIST_FILTER,
    text: text,
    role: role,
  };
};

export const userList = (param) => {
  return (dispatch) => {
    dispatch(userlListStart());
    axios.get("/user")
      .then((response) => {
          if (response.data.status === 200) {
              dispatch(userListSuccess(response.data.message, response.data.data, param.page));
          } else {
              dispatch(userListFail(response.data.message));
          }
      })
      .catch((error) => {
          dispatch(userListFail(error.message));
      });
  };
};

export const userDelete = (id) => {
  return async (dispatch) => {
    try {
      const response = await axios.delete(`user/delete/${id}`);
      
      if (response.data.status) {
        dispatch(userDeleteAction(id));
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };
};

export const getRoleList = () => {
  return (dispatch) => {
    const organisationId = localStorage.getItem("OrganisationID");

    axios
      .get(`/role?OrganisationID=${organisationId}`)
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(userRoleListAction(response.data.data, ""));
        } else {
          dispatch(userRoleListAction(null, "No Role"));
        }
      })
      .catch((error) => {
        console.error("Error fetching role list:", error);
        dispatch(userRoleListAction(null, "No Role"));
      });
  };
};

export const getOrganisationList = () => {
  return (dispatch) => {
    axios.get(`${BASE_URL}/organisation`).then((response) => {
      if (response.data.status === 200) {
        dispatch(userOrganisationListAction(response.data.data, ""));
      } else {
        dispatch(userOrganisationListAction(null, "No Organisation"));
      }
    });
  };
};

export const getuserDetail = (userId, updatedData) => {
  return (dispatch) => {
    axios
      // .post(`/user/update/${userId}`, updatedData) 
      .post(`/${userId}`, updatedData) 
      .then((response) => {
        dispatch(userDetail(response.data.data, "")); 
      })
      .catch((error) => {
        console.error("Error updating user details:", error);
      });
  };
};

export const addEditUser = (formData) => {
  return (dispatch) => {
    dispatch(userAddEditStart());
    axios
      .post("/user", formData)
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result;
          const msg = response.data.message;
          dispatch(userAddEditSuccess(msg, data));
        } else {
          dispatch(userAddEditFail(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(userAddEditFail(error.response.data.message));
      });
  };
};

export const addEditErrorNull = () => {
  return (dispatch) => {
    dispatch(userAddEditFail(null));
  };
};

export const userListFilter = (text, role) => {
  return (dispatch) => {
    dispatch(userFilterList(text, role));
  };
};
